<template>
    <div class="hdlist">
        <el-row class="hd_row" :gutter="25">
          <el-col  :span="8"  v-for="(v,index) in listVal" :key="index">
            <!-- <router-link :to="{ name: 'Details', params: { id: v.id }}">
            <div class="el-card">
              <img :src="v.banner" class="image">
              <div class="hd_text">
                <span class="title lh" :title="v.title">{{v.title}}</span>
                <div class="bottom clearfix">
                  <el-row>
                    <el-col :span="20">
                      <div class="">
                        <div class="time yh" :title="`主办方：${v.sponsor}`"><span style="background: #58B75B;" class="dotted" ></span>主办方：{{v.sponsor}}</div>
                        <div class="time yh" :title="`活动日期：${v.start_time}-${v.end_time}`"><span style="background: #FFB463;"  class="dotted"></span>活动日期：{{v.start_time}}-{{v.end_time}}</div>
                      </div>
                    </el-col>
                    <el-col :span="4" class="labels">
                        <img v-if="v.status == 3" src="@/assets/images/progress.png"/>
                        <img v-else-if="v.status == 4" src="@/assets/images/finished.png"/>
                        <img v-else-if="v.status == 2" src="@/assets/images/not_start.png"/>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="index_icons">
                <index-icons :goodsnum="v.mark" :commentnum="v.comment" :looknum="v.views" :joinsnum="v.join_num" :activityType="v.type"></index-icons>
              </div>
            </div>
            </router-link> -->
              <!-- 修改 -->
            <router-link :to="{ name: v.type==8 ? 'topic-lib-detail': 'Details', params: { id: v.id }}">
            <div class="el-card">
              <img :src="v.banner" class="image">
              <div class="hd_text">
                <span class="title lh" :title="v.title">{{v.title}}</span>
                <div class="bottom clearfix">
                  <el-row>
                    <el-col :span="20">
                      <div class="">
                        <div class="time yh" :title="`主办方：${v.sponsor}`"><span style="background: #58B75B;" class="dotted" ></span>主办方：{{v.sponsor}}</div>
                        <div class="time yh" :title="`活动日期：${v.start_time}-${v.end_time}`"><span style="background: #FFB463;"  class="dotted"></span>活动日期：{{v.start_time}}-{{v.end_time}}</div>
                      </div>
                    </el-col>
                    <el-col :span="4" class="labels">
                        <img v-if="v.status == 3" src="@/assets/images/progress.png"/>
                        <img v-else-if="v.status == 4" src="@/assets/images/finished.png"/>
                        <img v-else-if="v.status == 2" src="@/assets/images/not_start.png"/>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="index_icons">
                <index-icons :goodsnum="v.mark" :commentnum="v.comment" :looknum="v.views" :joinsnum="v.join_num" :activityType="v.type"></index-icons>
              </div>
            </div>
            </router-link>
          </el-col>
        </el-row>
    </div>
</template>

<script>
// topic-lib-detail
  import IndexIcons from '@/components/Icons'
    export default {
      name: 'IndexList',
      components:{
        IndexIcons
      },
      data () {
        return {

       };
      },
      props: ['listVal'],
      methods: {

      },
      computed:{
        // isShowJoin(){
        //   const ACTIVITY_TYPE = {
        //     'answer': 8,
        //     'clock': 5
        //   }
        //   let showJoinActivity = [ACTIVITY_TYPE.answer, ACTIVITY_TYPE.clock];
        //   if(showJoinActivity.includes(this.obj.type)){
        //     return true;
        //   }else{
        //     return  false;
        //   }
        // }
      }
    }
</script>

<style scoped>
    /* 活动列表部分 */



  .hdlist{
    width: 1200px;
    margin: 30px auto;
  }
  .hd_row{
    margin-bottom: 25px;
  }
  .hdlist .hd_text{
    padding: 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #EEEEEE;
  }
  .hd_text .title{
    display: inline-block;
    height: 45px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    /* margin-bottom: 10px; */
  }
  .hd_text .time{
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    font-size: 12px;
    margin: 10px 0px 10px 0px;
  }
  .hd_text .dotted{
    display: inline-table;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .hdlist .el-col-offset-2{
    margin: 0px !important;
  }
  .labels{
    text-align: right;
    height: 42px;
    display: flex;
  }
  .labels img{
    width: 63px;
    height: 27px;
    margin-top: 15px;
    align-self: baseline;
  }
  .image {
    width: 100%;
    height: 160px;
    display: block;
  }
  .index_icons{
    margin-left: 14px;
  }
  .el-card{
    margin-top: 25px;
    /* height: 350px; */
  }

  @media (min-width: 1024px){
      .hd_text .title{
        height:60px ;
      }

    } /*>=1024的设备*/

    @media (min-width: 1100px) {

    } /*>=1100的设备*/
    @media (min-width: 1280px) {

    } /*>=1280的设备*/
</style>



// WEBPACK FOOTER //
// src/index/components/Lists.vue